/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'

const CoursesPage: FC = () => (
    <>
        <div className='row gy-0'>
            <h1 className='dashboard-hello'>
                Courses
            </h1>
        </div>
    </>
)

const CoursesWrapper: FC = () => {

    return (
        <>
            <CoursesPage />
        </>
    )
}

export { CoursesWrapper }
